import React, { useCallback, useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import Tooltip from "@mui/material/Tooltip";
import { IoMdArrowBack } from "react-icons/io";
import { FiEdit2 } from "react-icons/fi";
import API_URL from "../Config";
import "../forms/UserForm.css";
import "./miIndex.css";
import "../Views/voyageView.css";
import "../AllScheduleView/PreventiveSchedulesView.css";
import { formatMiNumber, parseMiApiError } from "./miIndexUtils";

function ViewLocation({ isSidebarExpanded }) {
  const navigate = useNavigate();
  const { id } = useParams();

  const [loading, setLoading] = useState(true);
  const [locationData, setLocationData] = useState(null);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");

  const showSnackbar = useCallback((message, severity = "success") => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setSnackbarOpen(true);
  }, []);

  const handleSnackbarClose = (_, reason) => {
    if (reason === "clickaway") return;
    setSnackbarOpen(false);
  };

  const getDisplayValue = (value) =>
    value === null || value === undefined || value === "" ? "NA" : value;

  const loadLocation = useCallback(async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${API_URL}/api/mi/locations/${id}`, {
        headers: {
          Authorization: localStorage.getItem("authKey") || "",
        },
      });

      setLocationData(response.data || null);
    } catch (error) {
      showSnackbar(
        parseMiApiError(error, "Failed to load location details"),
        "error",
      );
    } finally {
      setLoading(false);
    }
  }, [id, showSnackbar]);

  useEffect(() => {
    loadLocation();
  }, [loadLocation]);

  if (loading) {
    return (
      <div
        className={`data-edit-form-content-container page-content mi-page ${
          isSidebarExpanded ? "expanded" : "collapsed"
        }`}
      >
        <div className="loader-container">
          <div className="loader"></div>
          <div>Loading location details...</div>
        </div>
      </div>
    );
  }

  if (!locationData) {
    return (
      <>
        <div
          className={`data-edit-form-content-container page-content mi-page ${
            isSidebarExpanded ? "expanded" : "collapsed"
          }`}
        >
          <div className="error-container">
            <div>Location details not found.</div>
          </div>
        </div>
        <Snackbar
          open={snackbarOpen}
          autoHideDuration={6000}
          onClose={handleSnackbarClose}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          style={{ marginTop: "35px", marginLeft: "20px" }}
        >
          <MuiAlert onClose={handleSnackbarClose} severity={snackbarSeverity}>
            {snackbarMessage}
          </MuiAlert>
        </Snackbar>
      </>
    );
  }

  return (
    <>
      <div
        className={`data-edit-form-content-container page-content mi-page ${
          isSidebarExpanded ? "expanded" : "collapsed"
        }`}
      >
        <div className="data-edit-form-content mi-page-layout">
          <div className="data-view-header">
            <div className="data-view-heading-content-left-side mi-standard-header__title">
              <Tooltip title="Back" arrow>
                <IoMdArrowBack
                  className="back-company"
                  onClick={() => navigate("/mi-locations")}
                />
              </Tooltip>
              <span>Location Details</span>
            </div>

            <div className="data-view-heading-content-right-side mi-standard-header__actions">
              <Link to={`/mi-edit-location/${locationData.location_id}`}>
                <button className="mi-btn mi-btn--secondary" type="button">
                  <FiEdit2 /> Edit Location
                </button>
              </Link>
            </div>
          </div>
          <div className="header-separator"></div>

          <div className="data-form-body-voyage">
            <div className="voyage-header-content">
              <div className="project-detailss">
                <div className="project-detail-arround">
                  <div className="project-details-left-side">
                    <div className="project-detail">
                      <div className="detail-header">Location Name:</div>
                      <div className="detail-part-voyage">
                        {getDisplayValue(locationData.location_name)}
                      </div>
                    </div>

                    <div className="project-detail">
                      <div className="detail-header">Location Type:</div>
                      <div className="detail-part-voyage">
                        {getDisplayValue(locationData.location_type)}
                      </div>
                    </div>

                    <div className="project-detail">
                      <div className="detail-header">Region:</div>
                      <div className="detail-part-voyage">
                        {getDisplayValue(locationData.region)}
                      </div>
                    </div>

                    <div className="project-detail">
                      <div className="detail-header">State Office:</div>
                      <div className="detail-part-voyage">
                        {getDisplayValue(locationData.state_office)}
                      </div>
                    </div>

                    <div className="project-detail">
                      <div className="detail-header">Zone:</div>
                      <div className="detail-part-voyage">
                        {getDisplayValue(locationData.zone)}
                      </div>
                    </div>

                    <div className="project-detail">
                      <div className="detail-header">Tankage Capacity:</div>
                      <div className="detail-part-voyage">
                        {locationData.tankage_capacity !== null &&
                        locationData.tankage_capacity !== undefined &&
                        locationData.tankage_capacity !== ""
                          ? formatMiNumber(locationData.tankage_capacity)
                          : "NA"}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        style={{ marginTop: "35px", marginLeft: "20px" }}
      >
        <MuiAlert onClose={handleSnackbarClose} severity={snackbarSeverity}>
          {snackbarMessage}
        </MuiAlert>
      </Snackbar>
    </>
  );
}

export default ViewLocation;
